// extracted by mini-css-extract-plugin
module.exports = {"model_lines_truncate":"anchor-menu-compatible_model_lines_truncate__rTCrp"};